import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, matchPath } from 'react-router-dom';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KeepSuggestedTriggerButton from 'automation-ui-canvas/components/panels/ai-assistant-panel/KeepSuggestedTriggerButton';
import GenerateTriggerButton from 'automation-ui-canvas/components/panels/ai-assistant-panel/GenerateTriggerButton';
import { getEnrollmentGenerationResponse } from 'automation-ui-canvas/selectors/aiAssistantSelectors';
import FilterDescriptionForms from 'automation-ui-enrollment/components/aiAssistant/FilterDescriptionForms';
import FeedbackFormForTriggers from 'automation-ui-enrollment/components/aiAssistant/FeedbackFormForTriggers';
import AiAssistantDisclaimer from 'automation-ui-enrollment/components/aiAssistant/AiAssistantDisclaimer';
import * as AbsolutePaths from 'automation-ui-canvas/constants/AbsolutePaths';
import AIFormControl from 'automation-ui-canvas/components/panels/ai-assistant-panel/AIFormControl';
import ContentAssistanceAlert from 'automation-ui-canvas/components/panels/ai-assistant-panel/ContentAssistanceAlert';
import { GET_AI_SETTINGS_ACCESS } from 'automation-ui-canvas/queries/aiSettingsQueries';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TriggersOptionPanelContent = ({
  flowId,
  hasExistingTrigger = false,
  onClickShowExistingTrigger
}) => {
  var _aiSettingsData$aiSet;
  const [error, setError] = useState(false);
  const [orFilterGroups, setOrFilterGroups] = useState([]);
  const generationResponse = useSelector(getEnrollmentGenerationResponse);
  const location = useLocation();
  const inReview = !!matchPath(location.pathname, AbsolutePaths.AI_ASSISTANT_GENERATE_TRIGGERS);
  const {
    data: aiSettingsData,
    loading: aiSettingsLoading
  } = useQuery(GET_AI_SETTINGS_ACCESS);
  const isAiEnabled = (_aiSettingsData$aiSet = aiSettingsData === null || aiSettingsData === void 0 ? void 0 : aiSettingsData.aiSettingsAccess.crmPropertiesEnabled) !== null && _aiSettingsData$aiSet !== void 0 ? _aiSettingsData$aiSet : false;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!inReview && /*#__PURE__*/_jsx(_Fragment, {
      children: !aiSettingsLoading && !isAiEnabled && /*#__PURE__*/_jsx(ContentAssistanceAlert, {
        marginBlockEnd: "300"
      })
    }), /*#__PURE__*/_jsx(AIFormControl, {
      label: /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.title"
        })
      }),
      help: !inReview && hasExistingTrigger && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "aiAssistantPanel.body.addTriggersPanel.replaceTriggerDescription_jsx",
        elements: {
          ButtonLink: Button
        },
        options: {
          onClick: onClickShowExistingTrigger,
          use: 'link'
        }
      }),
      error: error,
      validationMessage: error ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.error"
      }) : null,
      children: /*#__PURE__*/_jsx(FilterDescriptionForms, {
        onFiltersUpdated: updatedFiltersGroups => {
          setOrFilterGroups(updatedFiltersGroups);
        },
        readOnly: inReview,
        screen: "edit"
      })
    }), inReview ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Flex, {
        justifyContent: "space-between",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(KeepSuggestedTriggerButton, {
          flowId: flowId,
          orFilterGroups: orFilterGroups
        })
      }), /*#__PURE__*/_jsx(FeedbackFormForTriggers, {
        generationResponse: generationResponse,
        orFilterGroups: orFilterGroups
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockStart: "600",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(GenerateTriggerButton, {
          flowId: flowId,
          onError: setError,
          userInput: orFilterGroups
        })
      }), isAiEnabled && /*#__PURE__*/_jsx(AiAssistantDisclaimer, {})]
    })]
  });
};
export default TriggersOptionPanelContent;